import React from "react"

export default () => (
    <svg
        height="10"
        viewBox="0 0 8 10"
        width="8"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="m263.144956 28-1.144956 1.1791797 3.71005 3.8208203-3.71005 3.8208203 1.144956 1.1791797 4.855044-5z" 
            strokeWidth=".5"
            transform="translate(-261 -28)"
        />
    </svg>
)
